var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"tag-chip body3 my-1",attrs:{"color":"corporateBlue-lighten4","text-color":"corporateBlue-darken1","label":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  # "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }